import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Checkbox,
  TextField,
  Button,
  Box,
  Grid,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useTranslation } from "react-i18next";

const BookingModal = ({
  open,
  onClose,
  estimatedata,
  tripInstructions,
  roundTrip,
  handleChange,
  otherPerson,
  setOtherPerson,
  settings,
  payment_mode,
  confirmBooking,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 16,
          padding: 16,
          width: "600px",
          margin: "80px auto 40px",
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 16,
          top: 16,
          color: "rgba(0, 0, 0, 0.54)",
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        {/* <Typography variant="h5" sx={{ fontWeight: 600, mb: 4, mt: 2 }}>
          {t("roundTrip")}
        </Typography> */}

        {/* <FormControl component="fieldset" sx={{ mb: 3, width: "100%" }}>
          <RadioGroup
            row
            name="roundTrip"
            value={roundTrip}
            onChange={handleChange}
          >
            <FormControlLabel
              value={0}
              control={<Radio color="primary" />}
              label={t("no")}
              sx={{ mr: 8 }}
            />
            <FormControlLabel
              value={1}
              control={<Radio color="primary" />}
              label={t("yes")}
            />
          </RadioGroup>
        </FormControl> */}

        <FormControlLabel
          control={
            <Checkbox
              checked={otherPerson}
              onChange={() => setOtherPerson(!otherPerson)}
              sx={{
                color: "#5BAA59",
                "&.Mui-checked": {
                  color: "#5BAA59",
                },
              }}
            />
          }
          label={t("for_other_person")}
          sx={{ mb: 2 }}
        />

        {otherPerson && (
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                name="otherPerson"
                variant="outlined"
                onChange={handleChange}
                placeholder={t("otherPerson")}
                InputProps={{
                  sx: {
                    backgroundColor: "#f9f9f9",
                    borderRadius: "4px",
                    "& fieldset": { border: "1px solid #e0e0e0" },
                    "&:hover fieldset": { borderColor: "#c0c0c0" },
                    "&.Mui-focused fieldset": { borderColor: "#5BAA59" },
                  },
                }}
                sx={{
                  mb: 2,
                  "& .MuiInputLabel-root": {
                    display: "none",
                  },
                  "& .MuiInputBase-input": {
                    padding: "15px",
                    color: "#757575",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                name="otherPersonPhone"
                variant="outlined"
                onChange={handleChange}
                placeholder={t("otherPersonPhone")}
                InputProps={{
                  sx: {
                    backgroundColor: "#f9f9f9",
                    borderRadius: "4px",
                    "& fieldset": { border: "1px solid #e0e0e0" },
                    "&:hover fieldset": { borderColor: "#c0c0c0" },
                    "&.Mui-focused fieldset": { borderColor: "#5BAA59" },
                  },
                }}
                sx={{
                  "& .MuiInputLabel-root": {
                    display: "none",
                  },
                  "& .MuiInputBase-input": {
                    padding: "15px",
                    color: "#757575",
                  },
                }}
              />
            </Grid>
          </Grid>
        )}

        <Typography
          variant="subtitle1"
          sx={{ mb: 1, fontWeight: 400, color: "#21272A" }}
        >
          {t("note_to_driver")} ({t("optional")})
        </Typography>

        <TextField
          fullWidth
          name="tripInstructions"
          variant="outlined"
          value={tripInstructions}
          onChange={handleChange}
          placeholder={t("write_message_here")}
          multiline
          rows={1}
          sx={{
            mb: 4,
            "& .MuiOutlinedInput-root": {
              backgroundColor: "#f9f9f9",
              "& fieldset": {
                borderColor: "#e0e0e0",
              },
              "&:hover fieldset": {
                borderColor: "#c0c0c0",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#5BAA59",
              },
            },
            "& .MuiInputBase-input": {
              color: "#a0a0a0",
              fontStyle: "italic",
              padding: "12px 14px",
            },
          }}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 2,
          }}
        >
          <Box>
            <Typography
              variant="h6"
              sx={{ fontWeight: 400, color: "#4B545A", mb: 1 }}
            >
              {t("payment_method")}
            </Typography>

            <FormControl component="fieldset" sx={{ mt: 0 }}>
              <RadioGroup
                row
                name="payment_mode"
                value={payment_mode}
                onChange={handleChange}
              >
                <FormControlLabel
                  value={0}
                  control={
                    <Radio
                      sx={{
                        color: "#5BAA59",
                        "&.Mui-checked": {
                          color: "#5BAA59",
                        },
                      }}
                    />
                  }
                  label={t("wallet")}
                  sx={{ mr: 4 }}
                />
                <FormControlLabel
                  value={1}
                  control={
                    <Radio
                      sx={{
                        color: "#5BAA59",
                        "&.Mui-checked": {
                          color: "#5BAA59",
                        },
                      }}
                    />
                  }
                  label={t("cash")}
                />
              </RadioGroup>
            </FormControl>
          </Box>

          <Box sx={{ textAlign: "right" }}>
            <Typography
              variant="subtitle2"
              sx={{ color: "#5BAA59", fontSize: "18px", mb: 1 }}
            >
              {t("total")}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography
                variant="body1"
                sx={{
                  color: "#757575",
                  mr: 1,
                  fontWeight: 500,
                  fontSize: "0.9rem",
                }}
              >
                {settings && settings.code ? settings.code : "CFA"}
              </Typography>
              <Typography
                variant="h4"
                sx={{
                  color: "#5BAA59",
                  fontWeight: 700,
                  letterSpacing: "-0.5px",
                }}
              >
                {estimatedata && estimatedata.estimate
                  ? estimatedata.estimate.estimateFare
                  : "0"}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{ display: "flex", justifyContent: "center", gap: "12px", mt: 4 }}
        >
          <Button
            variant="outlined"
            onClick={onClose}
            fullWidth
            sx={{
              borderRadius: 50,
              px: 6,
              py: 1.5,
              border: "2px solid #B3261E",
              borderColor: "#B3261E",
              color: "#B3261E",
              fontWeight: 500,
              textTransform: "none",
              fontSize: "16px",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "transparent",
                borderColor: "#7A3F77",
                color: "#7A3F77",
              },
            }}
          >
            {t("cancel")}
          </Button>

          <Button
            variant="contained"
            onClick={confirmBooking}
            endIcon={<ArrowForwardIcon />}
            fullWidth
            sx={{
              borderRadius: 50,
              px: 6,
              py: 1.5,
              backgroundColor: "#5BAA59",
              fontWeight: 700,
              textTransform: "none",
              fontSize: "16px",
              boxShadow: "0px 4px 10px rgba(142, 75, 139, 0.3)",
              "&:hover": {
                backgroundColor: "#F8DBF2",
                boxShadow: "F8DBF2",
              },
            }}
          >
            {t("book_ride")}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default BookingModal;
